import React from 'react'
import {
	RemoteErrorBoundary,
	type RemoteErrorBoundaryProps,
} from '@adsk/exo-skeleton-react'

const ExoRemoteErrorBoundary: React.FC<RemoteErrorBoundaryProps> = ({
	children,
	...props
}: RemoteErrorBoundaryProps) => {
	return (
		<RemoteErrorBoundary
			data-testid="remote-error-boundary"
			skipReportError={false}
			{...props}
		>
			{children}
		</RemoteErrorBoundary>
	)
}

export default ExoRemoteErrorBoundary
